import React from 'react';
import { IconButton } from '@material-ui/core';
import { SyncDisabled } from '@material-ui/icons';

type RevertButtonProps = {
  onRevert: () => void;
};

export const RevertButton = ({ onRevert }: RevertButtonProps): JSX.Element => {
  return (
    <IconButton size="small" onClick={onRevert} data-testid="override-revert-button">
      <SyncDisabled fontSize="small" />
    </IconButton>
  );
};
